const drawerWidth = 240

export default (theme) => ({
  drawerPaper: {
    position: 'fixed',
    [theme.breakpoints.down('xs')]: {
      position: 'fixed',
    },
    backgroundColor: theme.palette.secondary.main,
    whiteSpace: 'nowrap',
    width: drawerWidth,
    boxShadow: '10px 5px 5px rgba(0, 0, 0, 0.12)',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    boxShadow: 'none',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 10,
    [theme.breakpoints.up('xs')]: {
      width: '80px',
    },
    [theme.breakpoints.down('xs')]: {
      width: '0px',
    },
  },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  iconSubtext: {
    fontSize: 8.7,
    textAlign: 'center',
  },
  groupMenuText: {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  groupMenuItem: {
    '&:hover': {
      '& $groupMenuItemDelete, & $groupMenuItemEdit': {
        display: 'inline-block',
      },
    },
  },
  groupMenuItemDelete: {
    display: 'none',
    marginRight: '0px',
  },
  groupMenuItemEdit: {
    display: 'none',
    marginRight: '0px',
  },
  list: {},
  listItem: { color: '#fff' },
  listItemIcon: {
    color: '#fff',
    display: 'block',
    marginRight: 'auto',
    marginLeft: 'auto',
    minWidth: 0,
  },
  listItemText: { color: '#fff', marginLeft: 7 },
  icon: {
    height: '1em',
    display: 'block',
    marginRight: 'auto',
    marginLeft: 'auto',
    marginBottom: 4,
  },
  badge: { backgroundColor: 'red' },
})
